// extracted by mini-css-extract-plugin
export default {"optionsContainer":"ProgramSelection_optionsContainer__nzuKl","optionItem":"ProgramSelection_optionItem__1HGyM","optionLabel":"ProgramSelection_optionLabel__pydgc"};